.viewport {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(100vw, calc(var(--size-popover) + var(--space-8)));
  margin: 0;
  padding: var(--space-4);
  list-style: none;
  outline: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2-5);
  padding: var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-2);
}

.icon {
  width: var(--size-icon-lg);
  height: var(--size-icon-lg);
  flex-shrink: 0;
}

.info .icon {
  color: var(--color-accent-text);
}

.pass .icon {
  color: var(--color-pass);
}

.fail .icon {
  color: var(--color-fail);
}

.text {
  flex: 1;
  min-width: 0;
}

.title {
  font-weight: var(--weight-medium);
}

.description {
  color: var(--color-fg-muted);
  font-size: var(--text-sm);
}

.close {
  display: inline-flex;
  color: var(--color-fg-muted);
}

.close svg {
  width: var(--size-icon);
  height: var(--size-icon);
}
